class ForgdCustomOrder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.products = {};
    this.querySelectorAll('[data-forgd-product]').forEach((node) => {
      try {
        this.products[node.dataset.forgdProduct] = JSON.parse(node.textContent);
      } catch (error) {
        this.products[node.dataset.forgdProduct] = null;
      }
    });

    this.form = this.querySelector('.forgd-order-form');
    this.error = this.querySelector('[data-form-error]');
    this.checkoutButton = this.querySelector('[data-checkout-button]');
    this.checkoutLabel = this.querySelector('[data-checkout-label]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.quantityInput = this.querySelector('[data-order-quantity]');
    this.orderSizeProperty = this.querySelector('[data-order-size-property]');
    this.styleProperty = this.querySelector('[data-style-property]');
    this.colorProperty = this.querySelector('[data-color-property]');
    this.totalOutput = this.querySelector('[data-order-total]');
    this.unitOutput = this.querySelector('[data-unit-price]');
    this.summaryQuantityOutputs = this.querySelectorAll('[data-summary-quantity]');
    this.checkoutTotalOutputs = this.querySelectorAll('[data-checkout-total]');
    this.summaryImage = this.querySelector('[data-summary-image]');
    this.summaryProofImage = this.querySelector('[data-summary-proof-image]');
    this.summaryProofEmpty = this.querySelector('[data-summary-proof-empty]');
    this.colorOptions = this.querySelector('[data-color-options]');
    this.preview = this.querySelector('[data-towel-preview]');
    this.previewImage = this.querySelector('[data-artwork-preview]');
    this.previewEmpty = this.querySelector('[data-preview-empty]');
    this.previewColorOutputs = this.querySelectorAll('[data-preview-color]');
    this.previewTypeOutputs = this.querySelectorAll('[data-preview-type]');
    this.previewFileOutput = this.querySelector('[data-preview-file]');
    this.artworkInput = this.querySelector('[data-artwork-input]');
    this.uploadZone = this.querySelector('[data-upload-zone]');
    this.artworkTools = this.querySelector('[data-artwork-tools]');
    this.artworkScaleInput = this.querySelector('[data-artwork-scale]');
    this.artworkScaleOutput = this.querySelector('[data-artwork-scale-output]');
    this.artworkSmallerButton = this.querySelector('[data-artwork-smaller]');
    this.artworkLargerButton = this.querySelector('[data-artwork-larger]');
    this.artworkResetButton = this.querySelector('[data-artwork-reset]');
    this.artworkPositionProperty = this.querySelector('[data-artwork-position-property]');
    this.artworkWidthProperty = this.querySelector('[data-artwork-width-property]');

    this.quantity = Number(this.quantityInput?.value) || 25;
    this.selectedColor = '';
    this.selectedVariant = null;
    this.previewObjectUrl = '';
    this.artworkX = 0.5;
    this.artworkY = 0.5;
    this.artworkScale = 1;
    this.artworkDrag = null;

    const firstAvailableKey = ['sweat', 'sideline'].find((key) => this.products[key]);
    this.styleKey = firstAvailableKey || 'sweat';

    this.querySelectorAll('[data-select-style]').forEach((button) => {
      button.addEventListener('click', () => this.selectStyle(button.dataset.selectStyle));
    });

    this.querySelectorAll('[data-quantity]').forEach((button) => {
      button.addEventListener('click', () => {
        this.quantity = Number(button.dataset.quantity) || 1;
        this.querySelectorAll('[data-quantity]').forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
        if (this.quantityInput) this.quantityInput.value = String(this.quantity);
        if (this.orderSizeProperty) this.orderSizeProperty.value = `${this.quantity} towels`;
        this.updateSummaryQuantity();
        this.updateVariant();
      });
    });

    this.artworkInput?.addEventListener('change', () => this.previewArtwork());
    this.previewImage?.addEventListener('load', () => this.resetArtworkEditor());
    this.previewImage?.addEventListener('pointerdown', (event) => this.startArtworkDrag(event));
    this.previewImage?.addEventListener('pointermove', (event) => this.moveArtwork(event));
    this.previewImage?.addEventListener('pointerup', (event) => this.endArtworkDrag(event));
    this.previewImage?.addEventListener('pointercancel', (event) => this.endArtworkDrag(event));
    this.previewImage?.addEventListener('keydown', (event) => this.moveArtworkWithKeyboard(event));
    this.artworkScaleInput?.addEventListener('input', () => {
      this.artworkScale = Number(this.artworkScaleInput.value) / 100;
      this.renderArtwork();
    });
    this.artworkSmallerButton?.addEventListener('click', () => this.changeArtworkScale(-5));
    this.artworkLargerButton?.addEventListener('click', () => this.changeArtworkScale(5));
    this.artworkResetButton?.addEventListener('click', () => this.resetArtworkEditor());
    this.form?.addEventListener('submit', (event) => this.submitOrder(event));
    this.setArtworkToolsEnabled(false);
    if (typeof ResizeObserver !== 'undefined' && this.preview) {
      this.artworkResizeObserver = new ResizeObserver(() => this.renderArtwork());
      this.artworkResizeObserver.observe(this.preview);
    }
    this.selectStyle(this.styleKey);
  }

  selectStyle(key) {
    if (!['sweat', 'sideline'].includes(key)) return;
    this.styleKey = key;
    const product = this.products[key];

    this.querySelectorAll('[data-select-style]').forEach((button) => {
      button.classList.toggle('is-active', button.dataset.selectStyle === key);
    });

    const styleButton = this.querySelector(`[data-select-style="${key}"]`);
    const typeName = product?.title || styleButton?.querySelector('strong')?.textContent || key;
    this.previewTypeOutputs.forEach((output) => {
      output.textContent = typeName;
    });

    if (this.preview) {
      this.preview.classList.remove('forgd-towel--sweat', 'forgd-towel--sideline');
      this.preview.classList.add(`forgd-towel--${key}`);
    }
    if (this.styleProperty) this.styleProperty.value = typeName;
    this.summaryImage?.classList.toggle('is-sideline', key === 'sideline');

    this.renderColors(product);
    this.updateVariant();
    requestAnimationFrame(() => this.renderArtwork());
    setTimeout(() => this.renderArtwork(), 400);
  }

  renderColors(product) {
    if (!this.colorOptions) return;
    this.colorOptions.replaceChildren();

    if (!product) {
      const message = document.createElement('span');
      message.className = 'forgd-loading-option';
      message.textContent = 'This towel product is not published or its handle does not match.';
      this.colorOptions.append(message);
      this.selectedColor = '';
      this.updatePreviewColor('—', '#d9d9d9');
      return;
    }

    const colorIndex = this.getColorOptionIndex(product);
    let colors = colorIndex >= 0
      ? product.variants.map((variant) => variant.options[colorIndex]).filter(Boolean)
      : ['Default'];
    colors = [...new Set(colors)];
    this.selectedColor = colors[0] || '';

    colors.forEach((color, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `forgd-color${index === 0 ? ' is-active' : ''}`;
      button.setAttribute('aria-label', `Select ${color} towel`);

      const swatch = document.createElement('i');
      swatch.setAttribute('aria-hidden', 'true');
      swatch.style.background = this.swatchColor(color);
      const label = document.createElement('span');
      label.textContent = color;
      button.append(swatch, label);

      button.addEventListener('click', () => {
        this.selectedColor = color;
        this.colorOptions.querySelectorAll('.forgd-color').forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
        this.updateVariant();
      });
      this.colorOptions.append(button);
    });
  }

  getColorOptionIndex(product) {
    if (!Array.isArray(product?.options)) return -1;
    return product.options.findIndex((option) => /colou?r/i.test(String(option)));
  }

  getOrderSizeOptionIndex(product) {
    if (!Array.isArray(product?.options)) return -1;
    return product.options.findIndex((option) => /order\s*size|order\s*quantity|quantity|qty|pack\s*size/i.test(String(option)));
  }

  orderSizeMatches(value) {
    const match = String(value || '').match(/\d+/);
    return match ? Number(match[0]) === this.quantity : false;
  }

  updateVariant() {
    const product = this.products[this.styleKey];
    this.selectedVariant = null;

    if (product?.variants?.length) {
      const colorIndex = this.getColorOptionIndex(product);
      const orderSizeIndex = this.getOrderSizeOptionIndex(product);
      const matchesSelection = (variant) => {
        const matchesColor = colorIndex < 0 || !this.selectedColor || variant.options[colorIndex] === this.selectedColor;
        const matchesOrderSize = orderSizeIndex < 0 || this.orderSizeMatches(variant.options[orderSizeIndex]);
        return matchesColor && matchesOrderSize;
      };
      const matchingVariants = product.variants.filter(matchesSelection);
      if (matchingVariants.length) {
        this.selectedVariant =
          matchingVariants.find((variant) => variant.available) || matchingVariants[0];
      } else {
        this.selectedVariant = null;
      }
    }

    if (this.variantInput) this.variantInput.value = this.selectedVariant?.id || '';
    if (this.colorProperty) {
      this.colorProperty.value = this.selectedColor === 'Default' ? '' : this.selectedColor;
    }

    const previewColor = this.selectedColor === 'Default' ? 'Natural' : this.selectedColor || '—';
    this.updatePreviewColor(previewColor, this.swatchColor(this.selectedColor));

    const canPurchase = Boolean(this.selectedVariant?.available);
    if (this.checkoutButton) this.checkoutButton.disabled = !canPurchase;
    if (this.checkoutLabel) {
      this.checkoutLabel.textContent = canPurchase
        ? this.dataset.checkoutReadyLabel || 'CONTINUE TO PAYMENT'
        : this.selectedVariant
          ? 'SELECTED OPTION IS SOLD OUT'
          : product
            ? 'ADD THIS ORDER SIZE IN SHOPIFY'
          : 'CHECK PRODUCT HANDLE';
    }
    this.updateQuantityPrices(product);
    this.updatePrice();
  }

  getVariantForQuantity(product, quantity) {
    if (!product?.variants?.length) return null;
    const colorIndex = this.getColorOptionIndex(product);
    const orderSizeIndex = this.getOrderSizeOptionIndex(product);
    const matchingVariants = product.variants.filter((variant) => {
      const matchesColor = colorIndex < 0 || !this.selectedColor || variant.options[colorIndex] === this.selectedColor;
      const matchesOrderSize = orderSizeIndex < 0 || this.orderSizeMatchesForQuantity(variant.options[orderSizeIndex], quantity);
      return matchesColor && matchesOrderSize;
    });
    return matchingVariants.find((variant) => variant.available) || matchingVariants[0] || null;
  }

  orderSizeMatchesForQuantity(value, quantity) {
    const match = String(value || '').match(/\d+/);
    return match ? Number(match[0]) === Number(quantity) : false;
  }

  updateQuantityPrices(product) {
    this.querySelectorAll('[data-quantity]').forEach((button) => {
      const quantity = Number(button.dataset.quantity) || 1;
      const variant = this.getVariantForQuantity(product, quantity);
      const unitOutput = button.querySelector('[data-tier-unit]');
      const totalOutput = button.querySelector('[data-tier-total]');
      button.classList.toggle('is-unavailable', Boolean(variant && !variant.available));
      if (!variant) {
        if (unitOutput) unitOutput.textContent = '— EACH';
        if (totalOutput) totalOutput.textContent = '— TOTAL';
        return;
      }
      const unitPrice = Number(variant.price) || 0;
      if (unitOutput) unitOutput.textContent = `${this.formatMoney(unitPrice)} EACH`;
      if (totalOutput) totalOutput.textContent = `${this.formatMoney(unitPrice * quantity)} TOTAL`;
    });
  }

  updateSummaryQuantity() {
    this.summaryQuantityOutputs.forEach((output) => {
      output.textContent = `${this.quantity} TOWELS`;
    });
  }

  updatePreviewColor(label, color) {
    this.previewColorOutputs.forEach((output) => {
      output.textContent = label;
    });
    if (this.preview) this.preview.style.setProperty('--towel-color', color || '#d9d9d9');
    if (this.summaryImage) this.summaryImage.style.setProperty('--towel-color', color || '#d9d9d9');
  }

  previewArtwork() {
    const file = this.artworkInput?.files?.[0];
    if (this.previewObjectUrl) URL.revokeObjectURL(this.previewObjectUrl);
    this.previewObjectUrl = '';

    if (!file) {
      if (this.previewImage) {
        this.previewImage.hidden = true;
        this.previewImage.removeAttribute('src');
        this.previewImage.style.removeProperty('width');
        this.previewImage.style.removeProperty('left');
        this.previewImage.style.removeProperty('top');
      }
      if (this.summaryProofImage) {
        this.summaryProofImage.hidden = true;
        this.summaryProofImage.removeAttribute('src');
        this.summaryProofImage.style.removeProperty('width');
        this.summaryProofImage.style.removeProperty('left');
        this.summaryProofImage.style.removeProperty('top');
      }
      if (this.summaryProofEmpty) this.summaryProofEmpty.hidden = false;
      if (this.previewEmpty) this.previewEmpty.hidden = false;
      if (this.previewFileOutput) this.previewFileOutput.textContent = 'NOT UPLOADED';
      if (this.artworkPositionProperty) this.artworkPositionProperty.value = '';
      if (this.artworkWidthProperty) this.artworkWidthProperty.value = '';
      this.setArtworkToolsEnabled(false);
      this.uploadZone?.classList.remove('has-file');
      return;
    }

    this.previewObjectUrl = URL.createObjectURL(file);
    if (this.previewImage) {
      this.previewImage.src = this.previewObjectUrl;
      this.previewImage.hidden = false;
    }
    if (this.summaryProofImage) {
      this.summaryProofImage.src = this.previewObjectUrl;
      this.summaryProofImage.hidden = false;
    }
    if (this.summaryProofEmpty) this.summaryProofEmpty.hidden = true;
    this.setArtworkToolsEnabled(true);
    if (this.previewEmpty) this.previewEmpty.hidden = true;
    if (this.previewFileOutput) this.previewFileOutput.textContent = file.name;
    this.uploadZone?.classList.add('has-file');
    const uploadTitle = this.uploadZone?.querySelector('span strong');
    if (uploadTitle) uploadTitle.textContent = 'IMAGE READY — CHANGE FILE';
  }

  setArtworkToolsEnabled(enabled) {
    this.artworkTools?.classList.toggle('is-active', enabled);
    [
      this.artworkScaleInput,
      this.artworkSmallerButton,
      this.artworkLargerButton,
      this.artworkResetButton,
    ].forEach((control) => {
      if (control) control.disabled = !enabled;
    });
  }

  resetArtworkEditor() {
    this.artworkX = 0.5;
    this.artworkY = 0.5;
    this.artworkScale = 1;
    if (this.artworkScaleInput) this.artworkScaleInput.value = '100';
    this.renderArtwork();
  }

  changeArtworkScale(amount) {
    if (!this.artworkScaleInput || this.artworkScaleInput.disabled) return;
    const minimum = Number(this.artworkScaleInput.min) || 25;
    const maximum = Number(this.artworkScaleInput.max) || 150;
    const nextValue = Math.min(maximum, Math.max(minimum, Number(this.artworkScaleInput.value) + amount));
    this.artworkScaleInput.value = String(nextValue);
    this.artworkScale = nextValue / 100;
    this.renderArtwork();
  }

  renderArtwork() {
    if (!this.preview || !this.previewImage || this.previewImage.hidden || !this.previewImage.naturalWidth) return;
    const towelRect = this.preview.getBoundingClientRect();
    if (!towelRect.width || !towelRect.height) return;

    const towelAspect = towelRect.width / towelRect.height;
    const artworkAspect = this.previewImage.naturalWidth / this.previewImage.naturalHeight;
    const baseWidthFraction = Math.min(0.62, (0.62 * artworkAspect) / towelAspect);
    const widthFraction = baseWidthFraction * this.artworkScale;
    const heightFraction = (widthFraction * towelAspect) / artworkAspect;
    const halfWidth = widthFraction / 2;
    const halfHeight = heightFraction / 2;

    this.artworkX = Math.min(1 - halfWidth, Math.max(halfWidth, this.artworkX));
    this.artworkY = Math.min(1 - halfHeight, Math.max(halfHeight, this.artworkY));

    this.previewImage.style.width = `${widthFraction * 100}%`;
    this.previewImage.style.left = `${this.artworkX * 100}%`;
    this.previewImage.style.top = `${this.artworkY * 100}%`;
    if (this.summaryProofImage) {
      this.summaryProofImage.style.width = `${widthFraction * 100}%`;
      this.summaryProofImage.style.left = `${this.artworkX * 100}%`;
      this.summaryProofImage.style.top = `${this.artworkY * 100}%`;
    }
    if (this.artworkScaleOutput) this.artworkScaleOutput.textContent = `${Math.round(this.artworkScale * 100)}%`;
    if (this.artworkPositionProperty) {
      this.artworkPositionProperty.value = `${Math.round(this.artworkX * 100)}% from left / ${Math.round(this.artworkY * 100)}% from top`;
    }
    if (this.artworkWidthProperty) {
      this.artworkWidthProperty.value = `${Math.round(widthFraction * 100)}% of towel width`;
    }
  }

  startArtworkDrag(event) {
    if (!this.previewImage || this.previewImage.hidden || (event.button !== undefined && event.button !== 0)) return;
    event.preventDefault();
    this.artworkDrag = {
      pointerId: event.pointerId,
      startClientX: event.clientX,
      startClientY: event.clientY,
      startArtworkX: this.artworkX,
      startArtworkY: this.artworkY,
    };
    this.previewImage.setPointerCapture?.(event.pointerId);
    this.previewImage.classList.add('is-dragging');
  }

  moveArtwork(event) {
    if (!this.artworkDrag || this.artworkDrag.pointerId !== event.pointerId || !this.preview) return;
    event.preventDefault();
    const towelRect = this.preview.getBoundingClientRect();
    if (!towelRect.width || !towelRect.height) return;
    this.artworkX = this.artworkDrag.startArtworkX + (event.clientX - this.artworkDrag.startClientX) / towelRect.width;
    this.artworkY = this.artworkDrag.startArtworkY + (event.clientY - this.artworkDrag.startClientY) / towelRect.height;
    this.renderArtwork();
  }

  endArtworkDrag(event) {
    if (!this.artworkDrag || this.artworkDrag.pointerId !== event.pointerId) return;
    this.previewImage?.releasePointerCapture?.(event.pointerId);
    this.previewImage?.classList.remove('is-dragging');
    this.artworkDrag = null;
  }

  moveArtworkWithKeyboard(event) {
    const movement = event.shiftKey ? 0.05 : 0.01;
    const directions = {
      ArrowLeft: [-movement, 0],
      ArrowRight: [movement, 0],
      ArrowUp: [0, -movement],
      ArrowDown: [0, movement],
    };
    const direction = directions[event.key];
    if (!direction) return;
    event.preventDefault();
    this.artworkX += direction[0];
    this.artworkY += direction[1];
    this.renderArtwork();
  }

  updatePrice() {
    this.updateSummaryQuantity();
    if (!this.selectedVariant) {
      if (this.totalOutput) this.totalOutput.textContent = '—';
      if (this.unitOutput) this.unitOutput.textContent = '—';
      this.checkoutTotalOutputs.forEach((output) => {
        output.textContent = '';
      });
      return;
    }
    const unitPrice = Number(this.selectedVariant.price) || 0;
    const totalPrice = this.formatMoney(unitPrice * this.quantity);
    if (this.unitOutput) this.unitOutput.textContent = this.formatMoney(unitPrice);
    if (this.totalOutput) this.totalOutput.textContent = totalPrice;
    this.checkoutTotalOutputs.forEach((output) => {
      output.textContent = `— ${totalPrice}`;
    });
  }

  formatMoney(cents) {
    const currency = this.dataset.currency || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency,
      }).format(cents / 100);
    } catch (error) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  swatchColor(name) {
    const value = String(name || '').trim().toLowerCase();
    const colors = {
      black: '#111111',
      white: '#f5f5f5',
      natural: '#d8d3ca',
      cream: '#e9e0ce',
      steel: '#6b7077',
      gray: '#85898e',
      grey: '#85898e',
      charcoal: '#343638',
      green: '#2f6b4f',
      red: '#a92323',
      blue: '#205fc5',
      navy: '#152742',
      orange: '#e36820',
      yellow: '#f1d13c',
      purple: '#633e8d',
      pink: '#d66e91',
      gold: '#b99335',
    };
    if (colors[value]) return colors[value];
    if (/^#[0-9a-f]{3,8}$/i.test(value)) return value;
    return '#d9d9d9';
  }

  submitOrder(event) {
    this.hideError();

    if (!this.selectedVariant?.available) {
      event.preventDefault();
      this.showError('Please select an available towel type and color.');
      return;
    }
    if (!this.form?.reportValidity()) {
      event.preventDefault();
      return;
    }

    this.checkoutButton.disabled = true;
    this.checkoutButton.classList.add('is-loading');
    this.checkoutLabel.textContent = 'OPENING SECURE CHECKOUT…';
    this.checkoutTotalOutputs.forEach((output) => {
      output.textContent = '';
    });
  }

  showError(message) {
    if (!this.error) return;
    this.error.textContent = message;
    this.error.hidden = false;
    this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  hideError() {
    if (!this.error) return;
    this.error.hidden = true;
    this.error.textContent = '';
  }
}

if (!customElements.get('forgd-custom-order')) {
  customElements.define('forgd-custom-order', ForgdCustomOrder);
}
